<template>
  <div id="berandaregu">
        <h1 class="title is-4">Data Regu</h1>
        <div id="navbar">
            <b-navbar class="has-background-white-ter">
              <!-- <template slot="brand">
              </template> -->
              <template slot="start">
                 <b-button  class="button is-success" 
                  tag="router-link"
                  to="/biro/dataregu"
                  @click ="tambahData()"
                 rounded icon-left="account-plus"
                 >Tambah Regu</b-button>
              </template>
              <template slot="end">
                <b-field position="is-centered">
                  <b-input placeholder="Search by Nama Regu, Guru Inti, Dosen Pembina"  type="search" v-model="search" icon="magnify">
                  </b-input>
              </b-field>
              </template>
            </b-navbar>
        </div>
     
        <div id="content">
          <div class="box">
             <section>
              <b-table
                  :data="filteredList"
                   bordered
                  striped
                  narrowed
                  hoverable
                  :loading="isLoading"
                  :mobile-cards="true"
                  paginated
                  :per-page="perPage"
                  ref="table"
                  :opened-detailed="detailOpened"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page">

                  <!-- <template v-slot="props"> -->
                 <b-table-column field="index" label="No" width="40" numeric v-slot="props">
                      {{ props.row.index }}
                  </b-table-column>
                  <b-table-column
                  field="id_regu"
                  label="ID"
                  sortable
                  :visible="false"
                  v-slot="props">
                  {{ props.row.id_regu}}
                  </b-table-column>

                  <b-table-column field="nama_regu" label="Nama Regu" 
                  sortable
                  v-slot="props">
                       {{ props.row.nama_regu}}
                  </b-table-column>

                  <b-table-column field="nama_guru" label="Ketua Regu" 
                  sortable
                  v-slot="props">
                      {{ props.row.nama_guru }}
                  </b-table-column>

                  <b-table-column field="nama_personil" label="Pembina" 
                  sortable
                  v-slot="props">
                      {{ props.row.nama_personil }}
                  </b-table-column>

                   <b-table-column field="jml_anggota_regu" label="Jumlah Guru Sasaran" 
                   sortable
                   v-slot="props">
                      {{ props.row.jml_anggota_regu }}
                  </b-table-column>

                   <b-table-column field="jml_siswa" label="Jumlah Siswa" 
                   sortable
                   v-slot="props">
                      {{ props.row.jml_siswa }}
                  </b-table-column>

                  <b-table-column v-slot="props" centered label="Action">
                     <span>
                      <b-dropdown aria-role="list" position="is-bottom-left">
                        <b-icon icon="dots-vertical" slot="trigger"></b-icon>
                        <b-dropdown-item aria-role="listitem">
                          <b-button tag="router-link" 
                          expanded icon-left="pencil" type="is-info" :to="'/biro/dataregu/' + props.row.id_regu">Edit
                          <!-- <b-icon icon="pencil" type="is-info"></b-icon> -->
                          </b-button>
                          </b-dropdown-item>
                        <b-dropdown-item aria-role="listitem">
                          <b-button expanded
                          icon-left="delete"
                          type="is-danger"
                          @click="confirmDelete(props.row.id_regu)">Hapus
                          <!-- <b-icon icon="delete" type="is-danger"></b-icon> -->
                          </b-button>
                        </b-dropdown-item>
                      </b-dropdown>
                    </span>
                  </b-table-column>

                    <template slot="bottom-left">
                     <div class="columns">
                      <div class="column">
                        <b-field horizontal label="Row">
                          <b-select v-model="perPage">
                          <option value="5">5 Per Page</option>
                          <option value="10">10 Per Page</option>
                          <option value="15">15 Per Page</option>
                          <option value="20">20 Per Page</option>
                          </b-select>
                        </b-field>
                      </div>
                     </div>
                  </template>

                  <template slot="empty">
                    <section class="section">
                      <div class=" content has-text-grey has-text-centered">
                        <!-- <p>
                          <b-icon
                          :icon ="tableLoadingIcon"
                          size="is-large">
                          </b-icon>
                        </p> -->
                        <p>{{ tableMessage }}</p>
                      </div>
                    </section>
                  </template> 
                  
              </b-table>
            </section>
           
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {
      regus:[],
      search:'',
      detailId:'',
      perPage:'5',
      activeBiro:Object,
      regu:{
        nama_regu:'',
        nama_personil:'',
        nama_guru:'',
        jml_anggota_regu:'',
        jml_siswa:''
      },

      //tableLoadingIcon:'sync',
      tableMessage:'Loading...',
      detailOpened:[],
      isLoading:true,
      snackbarMessage:'',
      config: {},
      gurus: [],
      siswas:[],
    }
  },
  computed:{
    filteredList()
    {
      return this.regus.filter(regu=>{
        return regu.nama_regu.toLowerCase().includes(this.search.toLowerCase()) ||
        regu.nama_personil.toLowerCase().includes(this.search.toLowerCase()) ||
        regu.nama_guru.toLowerCase().includes(this.search.toLowerCase()) 
        // String(regu.jml_anggota_regu).includes(this.search)
      })
    }

  },
  methods: {
    getDataByBiro()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'regu/biro/' + this.detailId
      this.regus = []

      this.$http.get(uri, this.config).then(response =>
      {
        this.regus = response.data.value
        console.log(this.regus)
        for(var i=0; i<this.regus.length; i++)
        {
          this.regus[i].index = i+1
        }
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false
      })
      .catch(error =>{
        this.errors = console.error
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    deleteData(deleteID)
    {
      this.isLoading = true
      var uri = this.$apiUrl + 'regu/delete/' + deleteID

      this.$http.post(uri, null, this.config).then(response=>
      {
        this.isLoading = false
        this.getDataByBiro();
        this.snackbarMessage = response
        this.snackbar('Data Berhasil dihapus','is-success')
      })
      .catch(error=>
      {
        this.isLoading = false
        this.errors = error
        console.log(error)
        this.snackbarMessage = "Silahkan coba hapus lagi"
        this.snackbar(this.snackbarMessage,'is-danger')
      })
    },
    async delete(deleteID)
    {
      try {
        for(var i=0; i<this.siswas.length; i++){
          await this.updateSiswaLama(this.siswas[i])
        }

        for(var i=0; i<this.gurus.length; i++){
          await this.updateGuruLama(this.gurus[i])
        }

        this.deleteData(deleteID)

        
      } catch (error) {
        
      }
    },
    
    snackbar(message,type)
    {
      this.$buefy.toast.open({
        duration: 5000,
        message:message,
        type:type,
        position:'is-top',
        actionText:'OK',
        queue:false,
      })
    },
    async updateSiswaLama(siswa){
      let dataSiswa = new FormData()
      dataSiswa.append("nama_siswa", siswa.nama_siswa)
      dataSiswa.append("email", siswa.email)
      dataSiswa.append("jenis_kelamin", siswa.jenis_kelamin)
      dataSiswa.append("tgl_lahir", siswa.tgl_lahir)
      dataSiswa.append("no_handphone", siswa.no_handphone)
      dataSiswa.append("kelas", siswa.kelas)
      dataSiswa.append("id_sekolah", siswa.id_sekolah)
      dataSiswa.append("id_regu", "")

      console.log(siswa)
      console.log(this.id_regu)

       var uri = this.$apiUrl + "siswa/" + siswa.id_siswa;
        this.$http
          .post(uri, dataSiswa, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
          });
    },

    async updateGuruLama(guru){
      let dataGuru = new FormData()
      dataGuru.append("nuptk", guru.nuptk)
      dataGuru.append("nama_guru", guru.nama_guru)
      dataGuru.append("jenis_kelamin", guru.jenis_kelamin)
      dataGuru.append("tgl_lahir", guru.tgl_lahir)
      dataGuru.append("no_handphone", guru.no_handphone)
      dataGuru.append("email", guru.email)
      dataGuru.append("mata_pelajaran", guru.mata_pelajaran)
      dataGuru.append("id_sekolah", guru.id_sekolah)
      dataGuru.append("id_regu", "")
      dataGuru.append("jenis_guru", "")

       var uri = this.$apiUrl + "guru/" + guru.id_guru;
        this.$http
          .post(uri, dataGuru, this.config)
          .then((response) => {
            console.log(response.data.value)
          })
          .catch((error) => {
          });
    },
    
    async getSiswa(editID) { //all guru
      var uri = this.$apiUrl + 'siswa/biro/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        var tempSiswa = response.data.value //get semua guru
        // this.gurus = response.data.value;
        console.log(editID)//tampil berdasarkan id regu
        console.log(tempSiswa)

        for(var i=0;i<tempSiswa.length;i++){
          if(tempSiswa[i].id_regu === editID){
            this.siswas.push(tempSiswa[i])
          }
        }

        console.log(this.siswas)
      });
    },

    async getGuru(editID) { //all guru
      var uri = this.$apiUrl + 'guru/biro/' + this.detailId
      this.$http.get(uri, this.config).then((response) => {
        var tempGuru = response.data.value //get semua guru
        // this.gurus = response.data.value;
        console.log(editID)//tampil berdasarkan id regu

        for(var i=0;i<tempGuru.length;i++){
          if(tempGuru[i].id_regu === editID){
            this.gurus.push(tempGuru[i])
          }
        }

        console.log(this.gurus)
        
      });
    },
    
    async confirmDelete(deleteID)
    {
      try {
        const guru = await this.getGuru(deleteID)
        const siswa = await this.getSiswa(deleteID)

        this.$buefy.dialog.confirm({
          title:'Hapus Regu',
          message:'Apa anda yakin ingin menghapus ?',
          confirmText:'Hapus',
          cancelText:'Batal',
          type:'is-danger',
          hasIcon:true,
          onConfirm:() => this.delete(deleteID)
        })
      } catch (error) {
        
      }
    }  
  },
  mounted()
  {
    if(this.$session.exists()){
      this.config = {
        headers: {
          'Authorization': 'Bearer ' + this.$session.get('token')
        }
      }
    }
    this.activeBiro = this.$session.get('biro')
      if(this.activeBiro)
      {
        this.detailId = this.activeBiro.id_biro
        this.getDataByBiro()
      }
  }
}
</script>

